(ns com.github.tamaikisage.arzulari-yogunlashtir.browser-data
  (:require [reagent.core :as r]))

(defonce current-route (r/atom nil))